export default "__VITE_ASSET__9e8c39d6__"